module.exports = __webpack_public_path__ + "static/codeBg-836427cbb1e195ade1ccdd572582bce7.png";